import type Folder from './folder';

let filesystem: Folder = {
	README: 'Welcome to the Internet! Have a look around',
	cool_stuff: {
		'cat.png.link': 'https://http.cat/100'
	}
};

// no, really, this does do the thing, I promise
// @ts-ignore
function _0x2e20() {
	var _0x3f9baf = [
		'\x69\x6d\x65\x20\x79\x6f\x75\x20\x73\x65',
		'\x34\x37\x32\x31\x36\x31\x36\x65\x79\x78\x63\x7a\x65',
		'\x65\x20\x6d\x65\x20\x3a\x29',
		'\x31\x32\x38\x31\x37\x31\x34\x71\x49\x73\x61\x4d\x72',
		'\x73\x20\x69\x73\x20\x61\x20\x63\x6f\x75',
		'\x20\x74\x68\x65\x20\x65\x61\x73\x74\x65',
		'\x74\x69\x6f\x6e\x73\x20\x79\x6f\x75\x20',
		'\x72\x20\x65\x67\x67\x21\x20\x74\x68\x69',
		'\x65\x20\x28\x31\x29\x20\x68\x75\x67\x20',
		'\x39\x39\x39\x30\x33\x34\x49\x51\x4e\x7a\x5a\x50',
		'\x31\x31\x36\x30\x35\x30\x34\x31\x6a\x6c\x48\x4e\x64\x4e',
		'\x61\x73\x73\x69\x67\x6e',
		'\x63\x6f\x6e\x67\x72\x61\x74\x75\x6c\x61',
		'\x31\x30\x68\x6b\x61\x7a\x63\x65',
		'\x31\x30\x38\x31\x32\x30\x34\x4f\x65\x56\x67\x45\x67',
		'\x33\x32\x49\x45\x4b\x68\x47\x67',
		'\x32\x31\x34\x39\x33\x38\x36\x74\x41\x6e\x41\x66\x59',
		'\x74\x68\x65\x20\x6e\x65\x78\x74\x20\x74',
		'\x31\x34\x31\x31\x39\x39\x38\x69\x50\x58\x69\x4e\x41'
	];
	_0x2e20 = function () {
		return _0x3f9baf;
	};
	return _0x2e20();
}
var _0x49b7db = _0x5e87;
function _0x5e87(_0x205e2e, _0x59d5f8) {
	var _0x2e20c7 = _0x2e20();
	return (
		(_0x5e87 = function (_0x5e874a, _0x53f688) {
			_0x5e874a = _0x5e874a - 0x1ad;
			var _0x5a6325 = _0x2e20c7[_0x5e874a];
			return _0x5a6325;
		}),
		_0x5e87(_0x205e2e, _0x59d5f8)
	);
}
(function (_0x3e8a7f, _0xae8e69) {
	var _0xc4f591 = _0x5e87,
		_0x11a6c8 = _0x3e8a7f();
	while (!![]) {
		try {
			var _0x55b167 =
				parseInt(_0xc4f591(0x1b5)) / 0x1 +
				parseInt(_0xc4f591(0x1bf)) / 0x2 +
				-parseInt(_0xc4f591(0x1b9)) / 0x3 +
				-parseInt(_0xc4f591(0x1b1)) / 0x4 +
				(-parseInt(_0xc4f591(0x1b0)) / 0x5) * (parseInt(_0xc4f591(0x1b3)) / 0x6) +
				-parseInt(_0xc4f591(0x1ad)) / 0x7 +
				(-parseInt(_0xc4f591(0x1b2)) / 0x8) * (-parseInt(_0xc4f591(0x1b7)) / 0x9);
			if (_0x55b167 === _0xae8e69) break;
			else _0x11a6c8['push'](_0x11a6c8['shift']());
		} catch (_0x1954e0) {
			_0x11a6c8['push'](_0x11a6c8['shift']());
		}
	}
})(_0x2e20, 0xe50a3),
	Object[_0x49b7db(0x1ae)](filesystem, {
		'\x65\x61\x73\x74\x65\x72': {
			'\x65\x67\x67':
				_0x49b7db(0x1af) +
				_0x49b7db(0x1bc) +
				'\x68\x61\x76\x65\x20\x66\x6f\x75\x6e\x64' +
				_0x49b7db(0x1bb) +
				_0x49b7db(0x1bd) +
				_0x49b7db(0x1ba) +
				'\x70\x6f\x6e\x20\x66\x6f\x72\x20\x6f\x6e' +
				_0x49b7db(0x1be) +
				_0x49b7db(0x1b4) +
				_0x49b7db(0x1b6) +
				_0x49b7db(0x1b8)
		}
	});

export default filesystem;
